/* Keepsake Lines: mobile thumbnails under the main product gallery (Shopify media, pre-personalization).
   Hidden automatically once the Teeinblue gallery mounts (CSS) and on desktop widths. */
(function () {
  'use strict';
  if (location.pathname.indexOf('/products/') === -1) return;
  function slidesOf(g) {
    return Array.prototype.filter.call(g.querySelectorAll('slideshow-slide'), function (s) { return s.querySelector('img'); });
  }
  function setActive(strip, i) {
    var ts = strip.querySelectorAll('.kl-mt__t');
    for (var k = 0; k < ts.length; k++) ts[k].classList.toggle('is-on', k === i);
  }
  function nearestIndex(g, slides) {
    var box = slides[0] && slides[0].parentElement ? slides[0].parentElement.getBoundingClientRect() : g.getBoundingClientRect();
    var best = 0, bd = Infinity;
    for (var i = 0; i < slides.length; i++) {
      var r = slides[i].getBoundingClientRect();
      var d = Math.abs(r.left + r.width / 2 - (box.left + box.width / 2));
      if (d < bd) { bd = d; best = i; }
    }
    return best;
  }
  function build() {
    var g = document.querySelector('media-gallery');
    if (!g || g.closest('product-card, .product-card, dialog')) return;
    if (g.querySelector('.kl-mt')) return;
    var slides = slidesOf(g);
    if (slides.length < 2) return;
    var strip = document.createElement('div');
    strip.className = 'kl-mt';
    slides.forEach(function (s, i) {
      var im = s.querySelector('img');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'kl-mt__t' + (i === 0 ? ' is-on' : '');
      b.setAttribute('aria-label', 'Show image ' + (i + 1));
      var t = document.createElement('img');
      t.alt = '';
      t.loading = 'lazy';
      t.decoding = 'async';
      var src = im.currentSrc || im.src || '';
      if (src) {
        if (src.indexOf('width=') > -1) src = src.replace(/width=[0-9]+/, 'width=160');
        else src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      }
      t.src = src;
      b.appendChild(t);
      b.addEventListener('click', function (e) {
        e.preventDefault();
        try { s.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); } catch (err) { s.scrollIntoView(); }
        setActive(strip, i);
      });
      strip.appendChild(b);
    });
    g.appendChild(strip);
    var track = slides[0].parentElement;
    if (track) {
      var st = null;
      track.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () { setActive(strip, nearestIndex(g, slides)); }, 120);
      }, { passive: true });
    }
  }
  var t = null;
  function scan() { clearTimeout(t); t = setTimeout(build, 150); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  try { new MutationObserver(scan).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
})();

/* Keepsake Lines: protect personalization images (no long-press save / right-click / drag) and
   watermark overlay on the customer's processed photo previews. The main Teeinblue mockup already
   gets its watermark from kl-patch.css (Z4); anything it does not cover is tagged here as fallback. */
(function () {
  'use strict';
  function isTee(el) { return el && el.tagName === 'IMG' && (el.currentSrc || el.src || '').indexOf('teeinblue.com') > -1; }
  document.addEventListener('contextmenu', function (e) {
    var t = e.target;
    if (!t) return;
    if (isTee(t) || (t.closest && t.closest('.tee-platform-mockup, .kl-wmwrap'))) e.preventDefault();
  }, true);
  document.addEventListener('dragstart', function (e) {
    if (isTee(e.target)) e.preventDefault();
  }, true);
  function tag() {
    var imgs = document.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      if (!isTee(im)) continue;
      im.setAttribute('draggable', 'false');
      if (im.closest('.tee-mockup-item') || im.closest('[class*="cropper"]')) continue;
      var p = im.parentElement;
      if (p && !p.classList.contains('kl-wmwrap')) {
        p.classList.add('kl-wmwrap');
        try { if (getComputedStyle(p).position === 'static') p.style.position = 'relative'; } catch (e) {}
      }
    }
  }
  var t = null;
  function scan() { clearTimeout(t); t = setTimeout(tag, 200); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  try { new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
})();

/* Keepsake Lines: friendly note while the photo uploads and the AI preview is being generated. */
(function () {
  'use strict';
  if (location.pathname.indexOf('/products/') === -1) return;
  var NOTE = '✨ Our artist AI is painting your preview — ready in about 20–30 seconds…';
  function visible(el) { var r = el.getBoundingClientRect(); return r.width > 0 && r.height > 0; }
  setInterval(function () {
    var btn = null;
    var list = document.querySelectorAll('button');
    for (var i = 0; i < list.length; i++) {
      var b = list[i];
      if (/uploading|generating|processing/i.test(b.textContent || '') && visible(b) && !b.closest('.kl-zm, dialog')) { btn = b; break; }
    }
    var ex = document.querySelector('.kl-gen-note');
    if (btn) {
      if (!ex) {
        var n = document.createElement('div');
        n.className = 'kl-gen-note';
        n.setAttribute('role', 'status');
        n.textContent = NOTE;
        var host = btn.parentElement || btn;
        if (host.parentElement) host.parentElement.insertBefore(n, host.nextSibling);
      }
    } else if (ex) { ex.remove(); }
  }, 700);
})();

/* Keepsake Lines: golf prints (Watercolor Golf Course Map, Signature Hole Print) have no live preview.
   Explain the studio + proof process, adapt the confirmation text and hide the Preview button. */
(function () {
  'use strict';
  var p = location.pathname;
  if (p.indexOf('/products/watercolor-golf-course-map') === -1 && p.indexOf('/products/signature-hole-print') === -1) return;
  document.documentElement.classList.add('kl-golf');
  var CONFIRM = "I've checked the course name and location. I'll get a free proof by email before anything is printed.";
  var HTML = '<p class="kl-golf-trust__t">Drawn for you by our studio — you approve it before we print</p>' +
    '<ul class="kl-golf-trust__l">' +
    '<li><b>Your real course.</b> We trace it from satellite maps and add the yardages and par from its official scorecard.</li>' +
    '<li><b>Free proof by email in 24–48 h.</b> You see your finished print before anything is made.</li>' +
    '<li><b>Unlimited revisions.</b> Ask for as many changes as you like — we only print once you say it is perfect.</li>' +
    '<li><b>Happiness Promise.</b> Free reprint if it isn’t right.</li>' +
    '</ul>';
  function fixText() {
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      var v = n.nodeValue || '';
      if (v.indexOf('checked my preview') > -1 && v !== CONFIRM) n.nodeValue = CONFIRM;
    }
  }
  function hidePreview() {
    var list = document.querySelectorAll('button, a[role="button"]');
    for (var i = 0; i < list.length; i++) {
      var b = list[i];
      if ((b.textContent || '').trim().toLowerCase() === 'preview' && !b.closest('.kl-zm, dialog')) b.style.display = 'none';
    }
  }
  function addTrust() {
    if (document.querySelector('.kl-golf-trust')) return;
    var anchor = document.querySelector('.kl-tb-confirm-row');
    if (!anchor) {
      var lab = null, w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null), n;
      while ((n = w.nextNode())) { if ((n.nodeValue || '').indexOf('course name and location') > -1) { lab = n.parentElement; break; } }
      if (lab) anchor = lab.closest('label') || lab.parentElement;
    }
    if (!anchor || !anchor.parentElement) return;
    var box = document.createElement('div');
    box.className = 'kl-golf-trust';
    box.innerHTML = HTML;
    anchor.parentElement.insertBefore(box, anchor);
  }
  function run() { fixText(); hidePreview(); addTrust(); }
  var t = null;
  function scan() { clearTimeout(t); t = setTimeout(run, 250); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  try { new MutationObserver(scan).observe(document.body, { childList: true, subtree: true, characterData: true }); } catch (e) {}
})();